import React from 'react'; 
import WithConsumer from '../../context/WithConsumer';
import Gallery from '../global/Gallery';
import Image from '../global/Image';
import { Link } from 'react-router-dom';
import Footer from '../global/Footer';

const Project = ({ context }) => {

	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
    
    function handleScroll(_el) {  
	    _el.preventDefault();
	    window.scroll({
			top: (window.innerHeight - (document.getElementsByClassName('c-header')[0].clientHeight * 2)),
			behavior: "smooth"
  		});
    }
     
    if (post) {
	    	    
	    let pageClass = 'c-page c-page-' + post.slug + ' c-project';
	        	
    	if (post.gallery) {
			
		    const blocks = post.block; 
		    
		    console.log('gallery');
		    console.log(post);
			
			if (context.appError){
			
				return null; 
			
			} else {
				
				return (
					<>	
						<div className={pageClass}>
							
							<div className="c-page__inner">
								
								<div className="c-page__block c-page__block--no-space c-page__block--load-effect">
								
									<div className="l-grid">

										{post.gallery.length > 0 &&
											<div className="l-grid__col l-grid__col--top">
												<Gallery gallery={post.gallery} prev_url={post.prev_url} next_url={post.next_url}></Gallery>
											</div>
										}
										
									</div>
									
								</div>
								
								<div className="l-grid">
								
									<div className="l-grid__col">
									
										<div className="c-page__block c-page__block--no-space c-page__block--border-bottom c-page__block--load-effect">
										
											<div className="c-project__header">
												<h1 className="c-project__header__title" dangerouslySetInnerHTML={{__html:post.heading}}></h1>
												<a href="#" className="c-project__header__information" onClick={handleScroll} dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 16 8"><polygon style="fill:#878981;" points="8.11,7.82 0.43,0.93 1.1,0.18 8.1,6.47 14.89,0.19 15.57,0.93 "/></svg>Information'}}></a>
											</div>
											
										</div>
										
									</div>
																			
								</div>
								
								<div className="c-page__block c-page__block--load-effect">
								
									<div className="l-grid">
		
										<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--l-9-24 l-grid__col--l-push-6-24">
											
											<div className="c-page__block c-page__block--small-space c-page__block--mobile-border-bottom">
												<div className="c-project__meta">
													{post.meta.map((meta,i) =>
														{
															return (
																<div className="c-project__meta__item">
																	{meta.label &&
																		<h5 className="c-project__meta__item__label" dangerouslySetInnerHTML={{__html:meta.label}}></h5>
																	}
																	{meta.progress &&
																		<div className="c-project__meta__item__bar">
																			<div className="c-project__meta__bar__inset" style={{width:meta.progress+'%'}}></div>
																		</div>
																	}
																	{meta.text &&
																		<p className="c-project__meta__item__text" dangerouslySetInnerHTML={{__html:meta.text}}></p>
																	}
																</div>
															)
														}
													)}
												</div>
											</div>
										
										</div>
										
										<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--l-9-24">
											{post.info &&
												<div className="scope-text scope-text--light" dangerouslySetInnerHTML={{__html:post.info}}></div>
											}
										</div>
										
									</div>
																			
								</div>								
																	
								<Footer post={post} showfooter={true}></Footer>
								
							</div>
							
						</div>
						
					</>
				)
					
			}
		} else {
			return null;
		}
	} else {
		return null;
	}
};
export default WithConsumer(Project);